package game

import com.soywiz.kds.FastArrayList
import com.soywiz.kds.iterators.fastForEach
import com.soywiz.kds.iterators.fastForEachWithIndex
import com.soywiz.korau.sound.Sound
import com.soywiz.korau.sound.readSound
import com.soywiz.korge.view.Views
import com.soywiz.korim.format.readBitmap
import com.soywiz.korio.async.launchImmediately
import com.soywiz.korio.dynamic.mapper.ObjectMapper
import com.soywiz.korio.dynamic.serialization.parseTyped
import com.soywiz.korio.dynamic.serialization.stringifyTyped
import com.soywiz.korio.file.std.localVfs
import com.soywiz.korio.file.std.resourcesVfs
import com.soywiz.korio.lang.Charset
import com.soywiz.korio.lang.Environment
import com.soywiz.korio.lang.expand
import com.soywiz.korio.serialization.json.Json
import kotlinx.coroutines.withContext
import kotlin.collections.set
import kotlin.coroutines.coroutineContext

suspend fun createGame(views: Views): Game {
    return withContext(views.coroutineContext) {
        val settings = loadSettings()
        val strings = loadStrings()
        val rooms = loadRooms()
        val font = loadFont()
        val sprites = loadSprites(rooms)
        val sounds = loadSounds()

        Game(settings, strings, font, rooms, sprites, sounds, views)
    }
}

suspend fun loadStrings(): Array<Map<String, String>> {
    val stringsEn = loadStringsLocale("stringsEn.properties")
    val stringsFr = loadStringsLocale("stringsFr.properties")
    return arrayOf(stringsEn, stringsFr)
}

private suspend fun loadStringsLocale(fileName: String): Map<String, String> {
    val strings = resourcesVfs["stringsEn.properties"].readString(Charset.forName("ASCII"))

    val map = mutableMapOf<String, String>()

    strings
        .split("\n")
        .map { it.trim() }
        .filter { it.isNotBlank() && it[0] != '#' }
        .fastForEach {
            val parts = it.split("=", limit = 2)
            val key = parts[0]
            val value = parts[1]
            map[key] = value
        }

    return map
}


private suspend fun loadSound(name: String, map: HashMap<String, Sound>) {
    val sound = resourcesVfs["sounds/$name.wav"].readSound()

    map[name] = sound
}

suspend fun loadSounds(messageCallback: (String) -> Unit = {}): Map<String, Sound> {
    val mapper = ObjectMapper().registerType<List<String>> {
        it["sounds"].genList()
    }

    val jsonSounds = resourcesVfs["sounds.json"].readString()
    val soundList = Json.parseTyped<List<String>>(jsonSounds, mapper)

    val sounds = hashMapOf<String, Sound>()
    soundList.fastForEachWithIndex { index, it ->
        val message = "   loaded $index/${soundList.size}"
        messageCallback.invoke(message)
        loadSound(it, sounds)
    }

    return sounds
}

suspend fun loadFont(): CgaFont {
    val fontBitmap = resourcesVfs["cgafont.png"].readBitmap()

    return CgaFont(fontBitmap)
}

suspend fun loadRooms(message: (String) -> Unit = {}): List<Room> {
    val mapper = wishlairObjectMapper()

    mapper.registerType<List<String>> {
        it["rooms"].genList()
    }

    val jsonRooms = resourcesVfs["rooms.json"].readString()

    val roomList = Json.parseTyped<List<String>>(jsonRooms, mapper)
    val rooms = FastArrayList<Room>()
    val ctx = coroutineContext

    val roomCount = roomList.size
    var counter = 0

    roomList.map {
        launchImmediately(ctx) {
            val room = try {
                val roomJson = resourcesVfs["rooms/${it}.json"].readString()

                counter++
                message.invoke("   loaded $counter/$roomCount")

                Json.parseTyped<Room>(roomJson, mapper)
            } catch (e: Exception) {
                Room()
            }

            room.id = it

            rooms.add(room)
        }
    }.forEach {
        it.join()
    }

    return rooms
}

suspend fun writeRoom(room: Room) {
    val mapper = wishlairObjectMapper()

    val json = Json.stringifyTyped(room, mapper, true)

//    val path = localVfs(Environment.expand("~/Projects/godlair/editor/src/commonMain/resources"))
//    path.get("./rooms/${room.id}.json").writeString(json)
    resourcesVfs["./rooms/${room.id}.json"].writeString(json)
}